export const sendForm = async (form: FormData) =>
  await fetch("https://media.us22.list-manage.com/subscribe/post", {
    method: "POST",
    mode: "no-cors",
    body: form,
  });
